import React from 'react';
import { Grid, makeStyles, TextField, InputAdornment, IconButton } from '@material-ui/core';
import { VisibilityOff, Visibility } from '@material-ui/icons';
import { connect } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { IState } from '../../../../config/rootReducer';
import {
  changeCurrentPasswordVisibility,
  CurrentPasswordValueAction,
} from '../../actions/ApplicationResetPasswordActions';

const PasswordFieldStyle = makeStyles({
  errorField: {
    borderWidth: '1px',
    borderColor: '#e10303',
  },
  warningText: {
    fontSize: 11,
    marginBottom: 10,
    color: '#ecab11',
  },
});

interface IPasswordField {
  password: string;
  label: string;
  changePassword: (newInput: string) => void;
  togglePasswordVisibility: () => void;
  showPassword: boolean;
  disabled: boolean;
}

/**
 * Campo de contraseña utilizado para escribir las nuevas contraseñas del usuario
 */
const CurrentPasswordField = ({
  password,
  label,
  changePassword,
  togglePasswordVisibility,
  disabled,
  showPassword,
}: IPasswordField) => {
  const classes = PasswordFieldStyle();

  const changePass = (event: React.ChangeEvent<HTMLInputElement>) =>
    changePassword(event.target.value);

  return (
    <Grid container={true} direction="column">
      <Grid item={true}>
        <TextField
          label={label}
          margin="none"
          variant="outlined"
          type={showPassword ? 'text' : 'password'}
          autoComplete="new-password"
          onInput={changePass}
          disabled={disabled}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={togglePasswordVisibility}>
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
          value={password}
        />
      </Grid>
    </Grid>
  );
};

const currentPasswordMapStateToProps = (state: IState) => {
  return {
    label: 'Contraseña actual',
    password: state.application.resetPassword.currentPassword.value,
    showPassword: state.application.resetPassword.currentPassword.visibility,
    disabled: state.application.resetPassword.disabledInput,
  };
};

const currentPasswordMapDispatchToProps = (dispatch: ThunkDispatch<IState, void, AnyAction>) => {
  return {
    changePassword: (newinput: string) => dispatch(CurrentPasswordValueAction(newinput)),
    togglePasswordVisibility: () => dispatch(changeCurrentPasswordVisibility()),
  };
};

export default connect(
  currentPasswordMapStateToProps,
  currentPasswordMapDispatchToProps
)(CurrentPasswordField);
